import { render, staticRenderFns } from "./companyInformation.vue?vue&type=template&id=5868e9e0&scoped=true&"
import script from "./companyInformation.vue?vue&type=script&lang=js&"
export * from "./companyInformation.vue?vue&type=script&lang=js&"
import style0 from "./companyInformation.vue?vue&type=style&index=0&id=5868e9e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5868e9e0",
  null
  
)

export default component.exports